<template>
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <b-form>
          <vue-form-generator :schema="schema" :model="model" />
        </b-form>
      </div>
    </div>
  </div>
</template>

<script>

import VueFormGenerator from 'vue-form-generator'

export default {
  name: 'ObjectGroupCreate',
  components: {
    'vue-form-generator': VueFormGenerator.component
  },
  data () {
    return {
      model: {
        name: '',
        submit: {}
      },
      schema: {
        fields: [
          {
            type: 'input',
            inputType: 'text',
            label: 'Name',
            model: 'name',
            required: true
          },
          {
            type: 'submit',
            buttonText: 'Save',
            onSubmit: this.onSave
          }
        ]
      }
    }
  },
  methods: {
    onSave () {
      var url = '/api/objectgroups'
      this.$http
        .post(url, { objectgroup: this._.omit(this.model, 'submit') })
        .then(response => {
        })
        .catch(error => console.log(error))
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ObjectManagement/ObjectGroupCreate.vue